module.exports = __webpack_public_path__ + "static/img/Suryadi.71cc65d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/Suryadi.png
// module id = 11NJ
// module chunks = 36